<template>
  <v-app>
    <v-container id="jobs-locations" class="jobs-locations">
      <v-row>
        <v-col cols="12" md="8" lg="8">
          <JobContent :job="job"/>
        </v-col>
        <v-col cols="12" md="4" lg="4">
          <Sidebar :job="job"/>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import JobContent from './components/Content';
import Sidebar from './components/Sidebar';
import api from '../../api';

export default {
  name: 'App',
  components: {
    JobContent,
    Sidebar
  },
  data: () => ({
    job: {}
  }),
  beforeMount() {
    // eslint-disable-next-line
    const jobId = pjVars.currentJob || false;
    api.getJob({id: jobId}).then(data => {
      this.job = data;
    });
  }
};
</script>

<style lang="scss">
@import '../../sass/main';
</style>

<style>
.job-title {
  margin-top: 0;
}

.v-divider {
  margin: 20px auto;
}

.job-subtitle {
  margin-top: 0 !important;
}

.apply-job-form-btn.v-btn.v-btn--contained.theme--light.v-size--default:hover {
  text-decoration: none;
}

.apply-job-form-dialog-close.v-btn.v-btn--absolute.v-btn--flat.v-btn--icon.v-btn--right.v-btn--round.v-btn--top.theme--light.v-size--default {
  background-color: transparent;
}

.apply-job-form-dialog-close.v-btn.v-btn--absolute.v-btn--flat.v-btn--icon.v-btn--right.v-btn--round.v-btn--top.theme--light.v-size--default:hover {
  text-decoration: none;
}

#apply-now-form-dist .forminator-row {
  margin-bottom: 20px;
}

#apply-now-form-dist .forminator-label {
  display: none;
}

#apply-now-form-dist .forminator-input, #apply-now-form-dist .forminator-textarea {
  background-color: #fff;
  border: 2px solid #ccc;
  color: #4A4A4A;
  font-family: "Avenir";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  border-radius: 5px;
  padding: 10px;
}

#apply-now-form-dist .wp-editor-container {
  border: 2px solid #ccc;
  border-radius: 5px;
}

#apply-now-form-dist .wp-editor-container .mce-btn > button {
  background-color: transparent;
}

#apply-now-form-dist .wp-editor-tools .wp-switch-editor {
  background-color: transparent !important;
}

#apply-now-form-dist .wp-editor-wrap.html-active .wp-editor-tools .wp-switch-editor.switch-html,
#apply-now-form-dist .wp-editor-wrap.tmce-active .wp-editor-tools .wp-switch-editor.switch-tmce {
  background-color: #f5f5f5 !important;
}

#apply-now-form-dist .forminator-button.forminator-button-submit {
  color: #fff;
  font-family: Zilla Slab;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 1px;
  line-height: 22px;
  text-align: center;
  border-radius: 8px;
  background-color: #243759 !important;
  padding: 20px !important;
  height: auto !important;
  width: 100%;
  display: block;
  margin: 0 auto;
}

#apply-now-form-dist [id^="upload"] .forminator-field {
  border-radius: 4px;
  background-color: #F6F7F9;
  padding: 20px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#apply-now-form-dist [id^="upload"] .forminator-field .forminator-button-upload {
  border: 1px solid #243759;
  border-radius: 8px;
  background-color: #FFFFFF;
  color: #243759;
  font-family: "Zilla Slab";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
  line-height: 17px;
  text-align: center;
}

#apply-now-form-dist [id^="upload"] .forminator-field .forminator-description {
  color: #4A4A4A;
  font-family: "Avenir";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
}

#apply-now-form-dist [id^="upload"] .forminator-field .forminator-button-upload {
  padding: 10px 20px;
}

#apply-now-form-dist [id^="upload"] .forminator-field .forminator-file-upload {
  order: 2;
  margin-top: 10px;
}

#apply-now-form-dist [id^="upload"] .forminator-field [data-empty-text] {
  display: block;
  width: 100%;
  margin: 10px 0 0;
  text-align: center;
}

#apply-now-form-dist [id^="upload"] .forminator-field .forminator-file-upload {
  display: block;
}

#apply-now-form-dist [id^="upload"] .forminator-field .forminator-button-upload {
  margin: 0;
}

#jobs-contact-form-dist .forminator-input, #jobs-contact-form-dist .forminator-textarea {
  background-color: #fff;
  border: 2px solid #ccc;
  color: #4A4A4A;
  font-family: "Avenir";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  border-radius: 5px;
  padding: 10px;
}

#jobs-contact-form-dist .forminator-label {
  display: none;
}

#jobs-contact-form-dist .forminator-row {
  margin-bottom: 20px;
}

#jobs-contact-form-dist .forminator-button.forminator-button-submit {
  border-radius: 8px;
  background-color: #243759;
}

#jobs-contact-form-dist #submit {
  text-align: right;
}

#jobs-contact-form-dist .forminator-button.forminator-button-submit {
  color: #FFFFFF;
  font-family: "Zilla Slab";
  font-size: 18px;
  letter-spacing: 1px;
  line-height: 22px;
  text-align: center;
}
</style>
